import { useApolloClient } from '@apollo/client';
import _ from 'lodash';

import { DISTINCT_CAR_KEYS_QUERIES } from './CarKeyQueries.graphql';

export const useCarKeys = () => {
  const client = useApolloClient();

  async function getData(variables: any): Promise<any[]> {
    const { data } = await client.query({
      query: DISTINCT_CAR_KEYS_QUERIES,
      variables,
    });
    return data?.distinctCarKeys || [];
  }

  async function getYears(): Promise<number[]> {
    const variables = { year: true };
    return _.orderBy(
      (await getData(variables)).map(x => x.year),
      [],
      ['desc'],
    );
  }

  async function getMakes(): Promise<string[]>;
  async function getMakes(year: number): Promise<string[]>;
  async function getMakes(param1?: number): Promise<string[]> {
    const variables = param1
      ? { year: true, make: true, filters: [{ field: 'year', intVal: param1 }] }
      : { make: true };
    return (await getData(variables)).map(x => x.make);
  }

  async function getModels(year: number, make: string): Promise<string[]> {
    const variables = {
      year: true,
      make: true,
      model: true,
      filters: [
        { field: 'year', intVal: year },
        { field: 'make', strVal: make },
      ],
    };
    return (await getData(variables)).map(x => x.model);
  }

  return { getYears, getMakes, getModels };
};
